import "./StripCalendarLegend.scss";
import { useTranslation } from "react-i18next";

const StripCalendarLegend = ({ reservePilot }) => {
  const { t } = useTranslation();

  return (
    <div className="strip-calendar-legend-container">
      <div className="strip-calendar-legend-details">
        <p className="legend-label">{t(`myBlockMonth.legend`)}</p>

        <div className={reservePilot ? 'grid-container-reserve' : 'legend-child-details'}>

          <p className={reservePilot ? "legend-rap-rsv-pairing":"legend-pairing"}>
            <span className="pairing-indicator legend-common-styles"></span>
            {reservePilot 
              ? <span className="pairing">{t(`myBlockMonth.reserveLegend`)}</span> 
              : <span className="pairing">{t(`myBlockMonth.pairingLegend`)}</span>
            }
          </p>
          {reservePilot ? (
            <>
              <p className="legend-release-reserve-strip">
                <span className="release-reserve-indicator-strip legend-common-styles"></span>
                <span className="release-reserve-strip">
                  {t(`myBlockMonth.releaseLegend`)}
                </span>
              </p>
              <p className="legend-guaranteedDayOff-strip">
                <span className="reserve-day-off-strip-indicator legend-common-styles"></span>
                <span className="reserve-day-off-strip">
                  {t(`myBlockMonth.reserveDayOffLegend`)}
                </span>
              </p>
              <p className="legend-displaced-pairing" style={{width: '17rem' }}>
                <span className="displaced-pairing-indicator legend-common-styles"></span>
                <span className="displaced-pairing">
                  {t(`myBlockMonth.displacePairingLegend`)}
                </span>
              </p>
            </>
            ) : (
              <>
                <p className="legend-displaced-pairing">
                  <span className="displaced-pairing-indicator legend-common-styles"></span>
                  <span className="displaced-pairing">
                    {t(`myBlockMonth.displacePairingLegend`)}
                  </span>
                </p>
                <p className="legend-reassignment-period">
                  <span className="reassignment-period-indicator legend-common-styles"></span>
                  <span className="reassignment-period">
                    {t(`myBlockMonth.reassignmentPeriodLegend`)}
                  </span>
                </p>
              </>
            )
          }

          <p className={reservePilot?'legend-training-reserve':'legend-training'}>
            <span className="training-indicator legend-common-styles"></span>
            <span className="training">
              {t(`myBlockMonth.trainingLegend`)}
            </span>
          </p>
          <p className={reservePilot?'legend-vacation-reserve':'legend-vacation'}>
            <span className="vacation-indicator legend-common-styles"></span>
            <span className="vacation">
              {t(`myBlockMonth.vacationLegend`)}
            </span>
          </p>

          <p className='legend-sick-day'>
            <span className="sick-day-indicator legend-common-styles"></span>
            <span className="sick-day">
              {t(`myBlockMonth.sickDayLegend`)}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default StripCalendarLegend;